'use strict'

export default {
  web: require('./web')
}
